import * as React from 'react';

const PriceTag24 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 24 24", width: 24, height: 24, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M6.832 8.58a1.31 1.31 0 0 0 1.86 0 1.334 1.334 0 0 0 0-1.876 1.31 1.31 0 0 0-1.86 0 1.334 1.334 0 0 0 0 1.875Z"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M13.468 2.89a2.88 2.88 0 0 0-2.268-.846L5.035 2c-.712.055-1.443.462-2.01 1.034S2.055 4.344 2 5.061l.213 6.048a2.93 2.93 0 0 0 .839 2.287l7.684 7.75a2.877 2.877 0 0 0 4.092 0l6.324-6.38a2.936 2.936 0 0 0 0-4.126zm-2.147.741c.383-.03.76.111 1.031.385l7.684 7.75a1.335 1.335 0 0 1 0 1.875l-6.324 6.379a1.307 1.307 0 0 1-1.86 0l-7.684-7.75a1.33 1.33 0 0 1-.382-1.04l-.212-6.047c.05-.652.935-1.546 1.582-1.596z"
  }
));
PriceTag24.Size = 24;
PriceTag24.Title = "PriceTag";

export { PriceTag24 as default };
